// copy values from .env to window.config (if they exist)
if (import.meta.env.VITE_REMOTE_URL) window.config.front_url = import.meta.env.VITE_REMOTE_URL;
if (import.meta.env.VITE_TENANT_ID) window.config.clientId = import.meta.env.VITE_TENANT_ID;
if (import.meta.env.VITE_SITE_ID) window.config.siteId = import.meta.env.VITE_SITE_ID;

if (import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS) window.config.enableLocalJackpots = import.meta.env.VITE_ENABLE_LOCAL_JACKPOTS === 'true' ? '1' : '';

if (import.meta.env.VITE_APP_PLATFORM) {
  if (import.meta.env.VITE_LOADER_URL) window.config.loaderImage = import.meta.env.VITE_LOADER_URL;
  if (import.meta.env.VITE_LOADER_TEXT) window.config.loaderText = import.meta.env.VITE_LOADER_TEXT;

  window.config.cordova = true;
  window.config.native_platform = import.meta.env.VITE_APP_PLATFORM;
}

if (import.meta.env.VITE_DEFAULT_LANGUAGE) window.config.defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE;

//DO NOT REMOVE - This is related to the popup switch
// check if newsite cookie is set
if (!document.cookie.includes('newsite=yes; expires')) {
  // get domain without www and subdomains
  // let domain = window.location.hostname.replace('www.', '');
  // domain = domain.split('.');
  // domain = domain[domain.length - 2] + '.' + domain[domain.length - 1];
  document.cookie = 'newsite=yes; expires=Tue, 01 Jan 2069 12:00:00 UTC;path=/';
}

const removeMeta = () => {
  try {
    document.querySelector('head>title').remove();
  } catch (e) { }

  const metas = [
    'description',
    'og:description',
    'twitter:description',
    'keywords',
    'og:keywords',
    'twitter:keywords',
    'og:site_name',
    'twitter:site',
    'twitter:creator',
    'og:image',
    'twitter:image',
    'og:image:width',
    'og:image:height',
    'og:image:alt',
    'twitter:image:alt',
    'og:type',
    'og:locale',
    'og:locale:alternate',
    'og:video',
    'og:video:width',
    'og:video:height',
    'og:video:type',
    'og:video:alt',
    'twitter:card',
    'thumbnail',
    'og:title',
  ];

  metas.forEach((meta) => {
    try {
      document.querySelector(`meta[property="${meta}"]`).remove();
    } catch (e) { }
  });

  const links = ['canonical', 'og:url', 'twitter:url'];

  links.forEach((meta) => {
    try {
      document.querySelector(`link[rel="${meta}"]`).remove();
    } catch (e) { }
  });
};
removeMeta();

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

if (urlParams.has('appEnv') && urlParams.get('appEnv') === 'flutter') { // mobile app
  window.config.appEnv = 'flutter';
  window.config.disableCookies = '1';
  document.documentElement.classList.add('flutter');

  if (urlParams.has('platformType')) {
    const platformType = urlParams.get('platformType');
    if (['1', '2', '3', '4'].includes(platformType)) {
      window.config.platformType = platformType;
    }
  }
}

if (urlParams.has('SourceSubBrand') && urlParams.get('SourceSubBrand') === '168') { // poker app
  window.config.appEnv = 'poker';
  window.config.disableCookies = '1';
  document.documentElement.classList.add('poker');

  if (urlParams.has('SourceProductPackage')) {
    let platformType = urlParams.get('SourceProductPackage');
    if (['6', '41', '122', '126'].includes(platformType)) {
      switch (platformType) {
        case '6':
        case '41':
          platformType = '1';
          break;
        case '122':
          platformType = '3';
          break;
        case '126':
          platformType = '4';
          break;
      }

      window.config.platformType = platformType;
    }
  }
}

if (window.config.appEnv === 'flutter' || window.config.appEnv === 'poker') {
  let originalHeight = document.scrollingElement.scrollHeight;
  window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');

  const resizeObserver = () => {
    if (originalHeight === document.scrollingElement.scrollHeight) return;
    //console.log('Body height changed:', document.scrollingElement.scrollHeight);

    originalHeight = document.scrollingElement.scrollHeight;
    window.parent.postMessage({ type: 'resize', data: { height: originalHeight } }, '*');
  };

  setInterval(resizeObserver, 1000);
}

if (urlParams.has('lng')) {
  let lng = urlParams.get('lng');
  if (lng && window.config.languages.includes(lng)) {
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch (e) { }
  }
}

if (urlParams.has('LangID')) {
  let lng = urlParams.get('LangID');

  const langs = {
    'ENG': 'en',
    'RUM': 'ro',
  };

  if (lng && langs[lng] && window.config.languages.includes(langs[lng])) {
    try {
      localStorage.setItem('i18nextLng', langs[lng]);
    } catch (e) { }
  }
}

const jsonDecodeConfig = () => {
  const toDecode = ['depositSettings', 'withdrawSettings'];
  toDecode.forEach((key) => {
    try {
      if (window?.config?.[key]) {
        window.config[key] = JSON.parse(window.config[key]);
      }
    } catch (e) {
      // do nothing;
    }
  });
};
jsonDecodeConfig();

if (navigator?.userAgent?.includes?.('https://github.com/prerender/prerender')) {
  window.config.disableCookies = '1';
  window.config.inPrerender = true;
}

switch (window.location.hostname) {
  case 'micros-front.newtongenius.com':
    window.config.clientId = '2';
    window.config.siteId = '2';
    break;
  case 'front-genius-joligames.slotmonitor.ro':
    window.config.clientId = '3';
    window.config.siteId = '3';
    break;
  case 'front-genius-dariosergio.slotmonitor.ro':
    window.config.clientId = '4';
    window.config.siteId = '4';
    break;
  case 'front-genius-imperafr.slotmonitor.ro':
    window.config.clientId = '5';
    window.config.siteId = '5';
    break;
  case 'front-genius-keops.slotmonitor.ro':
    window.config.clientId = '6';
    window.config.siteId = '6';
    break;
  case 'front-genius-platinumcasino.slotmonitor.ro':
    window.config.clientId = '7';
    window.config.siteId = '7';
    break;
}

/*
const extra = {
  'betsEnabled': '0',
  'recommendedBetsEnabled': '0',
  'recommendedGamesEnabled': '0',
  'challengesEnabled': '0',
  'liveCasinoEnabled': '0',
  'lottoEnabled': '0',
  'winnerFunEnabled': '0',
  'tournamentsMissionsEnabled': '0',
  'disableHappyHour': '1',
  'promoCalendarEnabled': '0',
  'momentumEnabled': '0',
  'socialEnabled': '0',
  'promoBubbleEnabled': '0',
  'airTimerEnabled': '0',
  'omniplayLottoEnabled': '0',
  'useCheckD': '0',
  'analyticsEnabled': '0',
  'pixelAnalyticsEnabled': '0'
};
Object.keys(extra).forEach((key) => {
  window.config[key] = extra[key];
});
*/
